import uniq from 'lodash.uniq';

const PRICE_50_100 = '50-100 þ. kr.';
const PRICE_100_150 = '100-150 þ. kr.';
const PRICE_150_200 = '150-200 þ. kr.';
const PRICE_200_250 = '200-250 þ. kr.';
const PRICE_250_300 = '250-300 þ. kr.';
const PRICE_300_PLUS = '300+ þ. kr.';

export const arrangeFiltersFromApartments = (apartments) => {
	const locationValues = uniq(apartments.map(it => it.Zip), 'Zip');
	const locations = locationValues.map(l => ({ id: l, label: l, value: l }));
	locations.sort((x, y) => x.value > y.value);
	const rooms = [
		{ id: '1', label: '1', value: '1' },
		{ id: '2', label: '2', value: '2' },
		{ id: '3', label: '3', value: '3' },
		{ id: '4+', label: '4+', value: '4+' }
	];

	const prices = [
		{ id: PRICE_50_100, label: PRICE_50_100, value: PRICE_50_100 },
		{ id: PRICE_100_150, label: PRICE_100_150, value: PRICE_100_150 },
		{ id: PRICE_150_200, label: PRICE_150_200, value: PRICE_150_200 },
		{ id: PRICE_200_250, label: PRICE_200_250, value: PRICE_200_250 },
		{ id: PRICE_250_300, label: PRICE_250_300, value: PRICE_250_300 },
		{ id: PRICE_300_PLUS, label: PRICE_300_PLUS, value: PRICE_300_PLUS },
	];

	return { locations, prices, rooms };
};

const matchesLocationFilters = (apartment, filters) => {
	return filters.length === 0 || filters.some(x => x.id === apartment.Zip);
};

const matchesPriceFilters = (apartment, filters) => {
	const price = Number(apartment.Rent);
	return filters.length === 0 || filters.some((x) => {
		switch(x.id) {
			case PRICE_50_100: {
				return price >= 50000 && price <= 100000;
			}
			case PRICE_100_150: {
				return price >= 100000 && price <= 150000;
			}
			case PRICE_150_200: {
				return price >= 150000 && price <= 200000;
			}
			case PRICE_200_250: {
				return price >= 200000 && price <= 250000;
			}
			case PRICE_250_300: {
				return price >= 250000 && price <= 300000;
			}
			case PRICE_300_PLUS: {
				return price >= 300000;
			}
			default: {
				return false;
			}
		}
	});
};

const matchesRoomCountFilters = (apartment, filters) => {
	return filters.length === 0 || filters.some(x => (x.id === '4+' && apartment.Rooms >= 4)
		|| Number(x.id) === apartment.Rooms);
};

export const filterApartments = (filters, apartments) => {
	const filteredApartments = apartments.filter(x => matchesLocationFilters(x, filters.selectedLocations)
		&& matchesPriceFilters(x, filters.selectedPrices)
		&& matchesRoomCountFilters(x, filters.selectedRoomCount));

	return filteredApartments;
};
